import { Name } from './components/Name';
import { Phone } from './components/Phone';
import { Email } from './components/Email';
import { Address1 } from './components/Address1';
import { Address2 } from './components/Address2';
import { City } from './components/City';
import { State } from './components/State';
import { CardPayment } from '../CardPaymentPanel/CardPayment';
import { usePaymentStore } from '../../../../state/paymentStore';
import { Zip } from './components/Zip';
import { isMobileScreen } from '@apply/ui';

export type PaymentInfoProps = {
    paymentError: string;
};

export const PaymentInfo: React.FC<PaymentInfoProps> = ({ paymentError }) => {
    const mobileScreen = isMobileScreen();
    const cardType = usePaymentStore((s) => s.cardType);

    const notSupportedCardType = cardType != 'VISA' && cardType != 'MASTERCARD' && cardType != undefined;

    const getColumnSize = (numberOfColumns: number, resizeForMobile = false) => {
        switch (numberOfColumns) {
            case 3:
                return resizeForMobile && mobileScreen ? '100%' : '32%';
            case 2:
                return resizeForMobile && mobileScreen ? '100%' : '49%';
            case 1:
                return '100%';
            default:
                return '100%';
        }
    };

    return (
        <div>
            <div>
                <div className='title'>Card Holder Info</div>
                <div className='payment-info-content'>
                    <Name />
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                        <div style={{ width: getColumnSize(2, true) }}>
                            <Phone />
                        </div>
                        <div style={{ width: getColumnSize(2, true) }}>
                            <Email />
                        </div>
                    </div>
                    <div
                        className='title'
                        style={{ marginTop: 40 }}
                    >
                        Billing Address
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                        <div style={{ width: getColumnSize(2, true) }}>
                            <Address1 />
                        </div>
                        <div style={{ width: getColumnSize(2, true) }}>
                            <Address2 />
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                        <div style={{ width: getColumnSize(3, true) }}>
                            <City />
                        </div>
                        <div style={{ width: getColumnSize(3, true) }}>
                            <State />
                        </div>
                        <div style={{ width: getColumnSize(3, true) }}>
                            <Zip />
                        </div>
                    </div>
                    <div
                        className='title'
                        style={{ marginTop: 40 }}
                    >
                        Card Information
                    </div>
                    <CardPayment disabled={false} />
                    {notSupportedCardType && (
                        <div className='payment-error'>We apologize, we currently only support Visa and Mastercard.</div>
                    )}
                    {!!paymentError?.length && <div className='payment-error'>{paymentError}</div>}
                </div>
            </div>
        </div>
    );
};
